import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 2492",
  "use": "icon-Path 2492-usage",
  "viewBox": "0 0 7.191 12.261",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.191 12.261\" id=\"icon-Path 2492\">\n  <path id=\"icon-Path 2492_Path_2492\" data-name=\"Path 2492\" d=\"M293.116,2184.685l-5.07,5.07,5.07,5.07\" transform=\"translate(294.177 2195.885) rotate(180)\" fill=\"none\" stroke=\"#5a0e0c\" stroke-linecap=\"round\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 2492.svg
// module id = 5/RP
// module chunks = 3